/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./task-list.vue?vue&type=template&id=4e45cdfa&scoped=true&"
import script from "./task-list.vue?vue&type=script&lang=js&"
export * from "./task-list.vue?vue&type=script&lang=js&"
import style0 from "./task-list.vue?vue&type=style&index=0&id=4e45cdfa&prod&lang=scss&scoped=true&"
import style1 from "./task-list.vue?vue&type=style&index=1&id=4e45cdfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e45cdfa",
  null
  
)

export default component.exports